import * as React from "react";

import NextMeeting from "../../containers/NextMeeting";
import OngoingMeetings from "./OngoingMeetings";
import { Divider } from "@mui/material";
import { usePageTitle } from "../../hooks";
import { HasPermission } from "../tools";
import { defineMessage } from "react-intl";

export default () => {
    usePageTitle(defineMessage({ id: "dashboard", defaultMessage: "Dashboard" }));

    return (
        <div style={{ marginTop: 20, width: "fit-content" }}>
            <OngoingMeetings />
            <HasPermission name={"edit_meeting"}>
                <Divider style={{ margin: "20px 0" }} />
                <NextMeeting />
            </HasPermission>
        </div>
    );
};
